
import { ReactNode } from 'react';

// Basic conditional wrapper
interface ConditionalProps {
  condition: boolean;
  children: ReactNode;
  fallback?: ReactNode;
}


export const Conditional = ({ condition, children, fallback = null }: ConditionalProps) => {
  return condition ? <>{children}</> : <>{fallback}</>;
};



// Switch-like conditional component
interface SwitchCase {
  when: boolean;
  children: ReactNode;
}

interface SwitchProps {
  fallback?: ReactNode;
  children: ReactNode;
}

export const Switch = ({ children, fallback = null }: SwitchProps) => {
  const cases = Array.isArray(children) ? children : [children];
  
  for (const child of cases) {
    if (child?.props?.when) {
      return <>{child}</>;
    }
  }
  
  return <>{fallback}</>;
};

export const Case = ({ when, children }: SwitchCase) => {
  return when ? <>{children}</> : null;
};
